import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Zap, Menu } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * Barra inferior do celular: uma ilha flutuante com atalhos e, no centro, o botão
 * de ativação em destaque. O modal de ativação é renderizado pelo Layout — aqui
 * só avisamos, porque o modal esconde esta barra ao abrir e levaria o modal junto.
 */
const ItemIlha = ({ item, ativo }) => (
  <Link
    to={item.path}
    className={`relative flex flex-col items-center gap-0.5 flex-1 py-1 rounded-xl transition-colors ${
      ativo ? 'text-white' : 'text-[#8E86A3]'
    }`}
  >
    {ativo && (
      <motion.span
        layoutId="ilhaAtiva"
        transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
        className="absolute -top-2 w-7 h-[3px] rounded-full bg-[#9B6BFF]"
      />
    )}
    <item.icon size={19} strokeWidth={ativo ? 2.4 : 2} />
    <span className="text-[10px] font-medium">{item.label}</span>
  </Link>
);

const MobileBottomNav = ({ onNovaAtivacao, onAbrirMenu }) => {
  const location = useLocation();

  const atalhos = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Início' },
    { path: '/activations', icon: Zap, label: 'Ativações' },
    { path: '/resellers', icon: Users, label: 'Revendas' },
  ];


  return (
    <>
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
        style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 10px)' }}
      >
        <nav className="pointer-events-auto mx-auto w-[calc(100%-28px)] max-w-md relative">
          {/* Botão de ativação, em destaque acima da ilha */}
          {/* O deslocamento horizontal vai no style do motion: a classe
              -translate-x-1/2 seria sobrescrita pela animação de toque, e o
              botão pulava para o lado no primeiro clique. */}
          <motion.button
            onClick={onNovaAtivacao}
            whileTap={{ scale: 0.93 }}
            transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            aria-label="Nova ativação"
            className="absolute left-1/2 -top-6 z-10 w-14 h-14 rounded-full flex items-center justify-center"
            style={{
              x: '-50%',
              background: 'linear-gradient(150deg, #A978FF, #6D3BD4)',
              boxShadow: '0 8px 26px rgba(155,107,255,0.5), 0 0 0 5px #0B0912',
            }}
          >
            <Zap size={24} className="text-white" fill="white" strokeWidth={1.5} />
          </motion.button>

          <div className="flex items-center justify-between gap-1 rounded-[22px] border border-white/10 bg-[#13101C]/95 backdrop-blur-xl px-2.5 py-2 shadow-[0_10px_34px_rgba(0,0,0,0.55)]">
            {atalhos.slice(0, 2).map((item) => (
              <ItemIlha key={item.path} item={item} ativo={location.pathname === item.path} />
            ))}

            <span className="w-12 flex-shrink-0" aria-hidden="true" />

            <ItemIlha item={atalhos[2]} ativo={location.pathname === atalhos[2].path} />
            <button
              onClick={onAbrirMenu}
              className="flex flex-col items-center gap-0.5 flex-1 py-1 rounded-xl text-[#8E86A3] active:text-white transition-colors"
            >
              <Menu size={19} />
              <span className="text-[10px] font-medium">Menu</span>
            </button>
          </div>
        </nav>
      </div>

    </>
  );
};

export default MobileBottomNav;
